
export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-white mb-6">
              Über Jo Allround Service
            </h2>
            <div className="space-y-6 text-gray-300">
              <p className="text-lg">
                Willkommen bei Jo Allround Service! Wir sind Ihr zuverlässiger Partner für alle 
                Handwerksarbeiten rund um Haus und Garten. Mit jahrelanger Erfahrung und 
                handwerklichem Know-how lösen wir Ihre Projekte professionell und termingerecht.
              </p>
              
              <div className="bg-green-900/30 p-6 rounded-lg border border-green-700">
                <h3 className="text-xl font-semibold text-green-400 mb-3">
                  Unser Standort
                </h3>
                <p className="text-green-200">
                  Unser Unternehmen bestand von 2007-2017 und ist seit 2023 wieder aktiv 
                  an unserem neuen Standort in OPR, Rheinsberg. Durch den Urlaubs-Wassersport 
                  sind wir nach Rheinsberg gekommen und haben Land und Leute lieben gelernt.
                </p>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex items-center">
                  <div className="w-8 h-8 flex items-center justify-center bg-green-600 rounded-full mr-3">
                    <i className="ri-check-line text-white"></i>
                  </div>
                  <span className="text-gray-300">Erfahrener Handwerker</span>
                </div>
                <div className="flex items-center">
                  <div className="w-8 h-8 flex items-center justify-center bg-green-600 rounded-full mr-3">
                    <i className="ri-check-line text-white"></i>
                  </div>
                  <span className="text-gray-300">Zuverlässiger Service</span>
                </div>
                <div className="flex items-center">
                  <div className="w-8 h-8 flex items-center justify-center bg-green-600 rounded-full mr-3">
                    <i className="ri-check-line text-white"></i>
                  </div>
                  <span className="text-gray-300">Faire Preise</span>
                </div>
                <div className="flex items-center">
                  <div className="w-8 h-8 flex items-center justify-center bg-green-600 rounded-full mr-3">
                    <i className="ri-check-line text-white"></i>
                  </div>
                  <span className="text-gray-300">Termingerechte Ausführung</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://static.readdy.ai/image/8fd098698619b27c03cb78789aa098a8/c82893b3892a6a3b88ca50697a21e3e1.jpeg"
              alt="Joachim Karl Born - Jo Allround Service"
              className="rounded-lg shadow-lg object-cover object-top w-full h-64 sm:h-80 lg:h-96"
            />
            <div className="absolute bottom-4 left-4 right-4 sm:bottom-6 sm:left-6 sm:right-auto bg-gray-900/80 p-3 sm:p-4 rounded-lg shadow-lg border border-green-700">
              <h4 className="font-semibold text-white text-sm sm:text-base">Unser Team von Jo-Allround Service</h4>
              <p className="text-green-400 text-xs sm:text-sm">Ihr Handwerker & Hausmeister</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
